import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography, Alert } from "@mui/material";
import axiosInstance from "../../../helpers/axios";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export default function EditBranch(props) {
  const { branchDetails } = props;
  const { onSuccess } = props;
  const decode = useCurrentUser();
  const user = null;
  const [formData, setFormData] = useState({
    branchName: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
  });

  const [error, setError] = useState({});
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setFormData({
      branchName: branchDetails?.branchName,
      address: branchDetails?.address,
      city: branchDetails?.city,
      district: branchDetails?.district,
      state: branchDetails?.state,
      pincode: branchDetails?.pincode,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required";
      }
    });

    if (formData.pincode && !/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Enter a valid 6-digit pincode";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    // API call here
    try {
      setLoading(true);
      const res = await axiosInstance.post(
        "/client-branches/info/edit",
        {
          clientId: decode.clientId,
          branchId: branchDetails?.branchId,
          ...formData,
        },
        {
          headers: {
          },
        }
      );
      if (res.status === 200) {
        setSuccess("Branch details updated successfully");

        setFormData({
          branchName: "",
          address: "",
          city: "",
          district: "",
          state: "",
          pincode: "",
        });
        setTimeout(() => {
          onSuccess();
          setSuccess("");
        }, 1200);
      }
    } catch (error) {
      setError({ apiError: "Failed to update details. Please try again." });
    }finally{
        setLoading(false)
    }
  };

  return (
    <Box Box sx={{ maxWidth: 600, mx: "auto", mt: 3, p: 3 }}>
      <Typography
        variant="h6"
        mb={3}
        sx={{
          fontFamily: "Outfit",
          fontWeight: "bold",
          color: "#626872",
          fontSize: "20px",
        }}
      >
        Edit Branch Detials
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Branch Name"
              name="branchName"
              value={formData.branchName}
              disabled
              onChange={handleChange}
              fullWidth
              error={!!error.branchName}
              helperText={error.branchName}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
              error={!!error.address}
              helperText={error.address}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              fullWidth
              error={!!error.city}
              helperText={error.city}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="District"
              name="district"
              value={formData.district}
              onChange={handleChange}
              fullWidth
              error={!!error.district}
              helperText={error.district}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="State"
              name="state"
              value={formData.state}
              onChange={handleChange}
              fullWidth
              error={!!error.state}
              helperText={error.state}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Pincode"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              fullWidth
              inputProps={{ maxLength: 6 }}
              error={!!error.pincode}
              helperText={error.pincode}
              InputLabelProps={{
                sx: {
                  fontFamily: "Outfit",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: "Outfit",
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              fullWidth 
              disabled={loading}
              sx={{
                mt: 1,
                textTransform: "none",
                color: "#fff",
                fontFamily: "Outfit",
              }}
            >
              {loading? "Please wait..": "Edit"}
            </Button>
          </Grid>
        </Grid>
        {error.apiError && (
          <Alert
            severity="error"
            sx={{
              mt: 3,
              fontFamily: "Outfit",
              "& .MuiAlert-message": { fontFamily: "Outfit" },
            }}
          >
            {error.apiError}
          </Alert>
        )}
        {success && (
          <Alert
            severity="success"
            sx={{
              mt: 3,
              fontFamily: "Outfit",
              "& .MuiAlert-message": { fontFamily: "Outfit" },
            }}
          >
            {success}
          </Alert>
        )}
      </Box>
    </Box>
  );
}
